import Translate from '@/filters/translate'
import stateNames from '@/core/states'

export default {
  props: { },
  data () { },
  computed: {
    isQliroEnabled () {
      const hostname = window.location.hostname.toLowerCase()
      const [ topDomain ] = hostname.match(/(localhost|\.\w{2,4}$)/gm)
      return ['.se'].indexOf(topDomain) > -1 && this.$store.getters.currency.currency === 'SEK'
    },

    firstName: {
      set (value) { this.$store.dispatch('setCheckoutFirstName', value) },
      get () { return this.$store.getters.checkoutFirstName }
    },

    lastName: {
      set (value) { this.$store.dispatch('setCheckoutLastName', value) },
      get () { return this.$store.getters.checkoutLastName }
    },

    fullName () {
      return this.firstName + ' ' + this.lastName
    },

    email: {
      set (value) { this.$store.dispatch('setCheckoutEmail', value) },
      get () { return this.$store.getters.checkoutEmail }
    },

    phoneMobile: {
      set (value) { this.$store.dispatch('setCheckoutPhoneMobile', value) },
      get () { return this.$store.getters.checkoutPhoneMobile }
    },

    address: {
      set (value) { this.$store.dispatch('setCheckoutAddress', value) },
      get () { return this.$store.getters.checkoutAddress }
    },

    city: {
      set (value) { this.$store.dispatch('setCheckoutCity', value) },
      get () { return this.$store.getters.checkoutCity }
    },

    state: {
      set (value) { this.$store.dispatch('setCheckoutState', value) },
      get () { return this.$store.getters.checkoutState }
    },

    stateName: {
      get () {
        const stateIsSet = this.$store.getters.checkoutState && this.$store.getters.checkoutState !== ''
        if (stateIsSet && this.country === 'US') {
          return stateNames[this.$store.getters.checkoutState]
        }
        return this.$store.getters.checkoutState
      }
    },

    postalCode: {
      set (value) { this.$store.dispatch('setCheckoutPostalCode', value) },
      get () { return this.$store.getters.checkoutPostalCode }
    },

    country: {
      set (value) { this.$store.dispatch('setCheckoutCountry', value) },
      get () { return this.$store.getters.checkoutCountry }
    },

    // shipping

    deliveryEmail: {
      set (value) { this.$store.dispatch('setCheckoutDeliveryEmail', value) },
      get () { return this.$store.getters.checkoutDeliveryEmail }
    },

    deliveryPhoneMobile: {
      set (value) { this.$store.dispatch('setCheckoutDeliveryPhoneMobile', value) },
      get () { return this.$store.getters.checkoutDeliveryPhoneMobile }
    },

    deliveryFirstName: {
      set (value) { this.$store.dispatch('setCheckoutDeliveryFirstName', value) },
      get () { return this.$store.getters.checkoutDeliveryFirstName }
    },

    deliveryLastName: {
      set (value) { this.$store.dispatch('setCheckoutDeliveryLastName', value) },
      get () { return this.$store.getters.checkoutDeliveryLastName }
    },

    deliveryAddress: {
      set (value) { this.$store.dispatch('setCheckoutDeliveryAddress', value) },
      get () { return this.$store.getters.checkoutDeliveryAddress }
    },

    deliveryCity: {
      set (value) { this.$store.dispatch('setCheckoutDeliveryCity', value) },
      get () { return this.$store.getters.checkoutDeliveryCity }
    },

    deliveryState: {
      set (value) { this.$store.dispatch('setCheckoutDeliveryState', value) },
      get () { return this.$store.getters.checkoutDeliveryState }
    },

    deliveryStateName: {
      get () {
        const stateIsSet = this.$store.getters.checkoutDeliveryState && this.$store.getters.checkoutDeliveryState !== ''
        if (stateIsSet && this.deliveryCountry === 'US') {
          return stateNames[this.$store.getters.checkoutDeliveryState]
        }
        return this.$store.getters.checkoutDeliveryState
      }
    },

    deliveryPostalCode: {
      set (value) { this.$store.dispatch('setCheckoutDeliveryPostalCode', value) },
      get () { return this.$store.getters.checkoutDeliveryPostalCode }
    },

    deliveryCountry: {
      set (value) { this.$store.dispatch('setCheckoutDeliveryCountry', value) },
      get () { return this.$store.getters.checkoutDeliveryCountry }
    },

    shippingMethod: {
      set (value) { this.$store.dispatch('setCheckoutShippingMethod', value.method) },
      get () { return this.$store.getters.shippingMethod }
    }
  },
  methods: {
    handleOrderError (response, location) {
      this.$store.dispatch('setAllowClosingBackdrop', true)
      this.$store.dispatch('showBackdrop', false)

      // Where the error occurred.
      switch (location) {
        case 'createOrder':
        case 'getSource':
        case 'payOrder':
        case 'setSVGs':
        case 'getOrder':
        case 'syncOrder':
        case 'createQliroOrder':
        case 'updateOrder':
          console.log('error in location \'' + location + '\'')
          break
      }

      // Make the error prepended by 'error' and make the location upper-case first, to match the translation strings:
      // payOrder --> errorPayOrder
      this.errorMessage = 'error' + location.substr(0, 1).toUpperCase() + location.substr(1)
      if (location === 'getSource' || location === 'handleCardAction' || location === 'payOrder' || location === 'confirmPayment') {
        if (response.error) {
          const stripeErrorMessage = Translate.translate(`stripe_${response.error.code}`)
          if (stripeErrorMessage !== `stripe_${response.error.code}`) {
            this.errorMessage = stripeErrorMessage
          } else {
            this.errorMessage = response.error.message
          }
        }
      }

      // Scroll to top.
      document.querySelector('body').scrollIntoView()
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/checkoutMixin.js